import { create } from 'zustand';

type ImmersiveState = {
  /** A surface has taken over the viewport, so the app chrome is covered. */
  immersive: boolean;
  setImmersive: (next: boolean) => void;
};

/**
 * Whether a surface has expanded to cover the app chrome (ticket 09's in-page full screen).
 *
 * The chrome is **covered, not unmounted** — which is what leaves the map instance untouched across
 * the transition (grilling Q8) — so without this flag the sidebar, page header, customer header and
 * tab bar all stay in the focus order and the accessibility tree behind the expanded map. A keyboard
 * or screen-reader user could then focus and activate a control they cannot see, and silently leave
 * the expanded view. Each piece of chrome reads this and marks ITSELF `inert`; nothing can inert an
 * ancestor of the map, because the map is a descendant of the shell.
 */
export const useImmersiveStore = create<ImmersiveState>((set) => ({
  immersive: false,
  setImmersive: (next) => set({ immersive: next }),
}));
